export const formatCurrency = (value) => {
  return value
    ? value
        .toFixed(2)
        .toString()
        .replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
    : '0.00';
};
